import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import DialogContent from '@mui/material/DialogContent'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
// styling for edit user details

export const StyledDialog = styled(Dialog)(({theme}) => ({
  padding: theme.spacing(4),
  width: '700px',
  margin: '0 auto'
}))

export const StyledTextField = styled(TextField)(({theme}) => ({
  '& .MuiOutlinedInput-root': {
    minHeight: '48px',
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}))
export const InputTitle = styled('div')(({theme}) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.h5.lineHeight,
  letterSpacing: '0.245536px',
  color: theme.palette.hpBlack
}))

export const SaveButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.hpPrimaryDark,
  color: theme.palette.hpWhite,
  borderRadius: '4px',
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  textTransform: 'none',
  padding: '8px 32px',
  minWidth: '100px',
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryDark
  },
  '&:disabled': {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.hpWhite
  }
}))

export const CancelButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.hpWhite,
  color: theme.palette.hpPrimaryDark,
  textTransform: 'capitalize',
  padding: '8px 24px',
  minWidth: '100px',
  fontSize: theme.typography.body1.fontSize,
  '&:hover': {
    backgroundColor: theme.palette.hpWhite,
    textDecoration: 'underline'
  }
}))

export const StyledDivFooter = styled('div')(({theme}) => ({
  paddingTop: theme.spacing(5),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: theme.spacing(2)
}))

export const StyledDivEmailText = styled('div')(({theme}) => ({
  color: theme.palette.hpBase
}))

export const StyledGrid = styled(Grid)(({theme}) => ({
  paddingTop: theme.spacing(3)
}))

export const StyledDivEmailAndFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}))

export const StyledDialogContent = styled(DialogContent)(({theme}) => ({
  padding: theme.spacing(5),
  paddingTop: theme.spacing(3),
  color: theme.palette.hpBlack
}))

export const StyledTemporaryAccessRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}))

export const StyledInputTitleInline = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  margin: 0
}))

export const StyledEndDateWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'checked'
})(({theme, checked}) => ({
  pointerEvents: checked ? 'auto' : 'none',
  '& .MuiOutlinedInput-root': {
    backgroundColor: checked ? 'transparent' : theme.palette.grey[100]
  }
}))
